import { Toast } from "utils/toast";
import { performQuery, performMutation } from "../../service/graphql";
import * as Query from "../../service/graphql/apiQuery";

export const CreateCustomer = (payload) => {
  console.log("customer", payload);
  return performMutation(Query.createCustomer, { ...payload })
    .then((response) => {
      // console.log(response, "response.data");
      Toast({
        type:
          response?.data?.customerCreate?.customer == null
            ? "error"
            : "success",
        message:
          response?.data?.customerCreate?.customer == null
            ? response?.data?.customerCreate?.customerUserErrors[0]?.message
            : "Account Created successfully",
      });
      return response;
    })
    .catch((err) => {
      console.log(err?.customerCreate, "eeeeeeeerrrrrrrr");
    });
};

export const GetAccessToken = (payload) => {
  // console.log("customer", payload);
  return performMutation(Query.getCustomerAccessTokenQuery, { ...payload })
    .then((response) => {
      console.log(response?.data,"response?.data");
      Toast({
        type:
          response?.data?.customerAccessTokenCreate?.customerAccessToken == null
            ? "error"
            : "success",
        message:
          response?.data?.customerAccessTokenCreate?.customerAccessToken == null
            ? response?.data?.customerAccessTokenCreate?.customerUserErrors[0]
              ?.message
            : "Logged in successfully",
      });
      return response;
    })
    .catch((err) => {
      console.log(err?.customerCreate, "eeeeeeeerrrrrrrr");
    });
};

export const ForgotPassword = (payload) => {
  // console.log("customer", payload);
  return performMutation(Query.forgotPasswordQuery, { ...payload })
    .then((response) => {
      // console.log(response, "respdataa");
      // Toast({
      //   type:
      //     response?.data?.customerAccessTokenCreate?.customerAccessToken == null
      //       ? "error"
      //       : "success",
      //   message:
      //     response?.data?.customerAccessTokenCreate?.customerAccessToken == null
      //       ? response?.data?.customerAccessTokenCreate?.customerUserErrors[0]
      //           ?.message
      //       : "Logged in successfully",
      // });
      return response;
    })
    .catch((err) => {
      Toast({ type: "error", message: err?.message });
    });
};

export const GetCustomerData = (payload) => {
  // console.log("customerdddddddddddd", payload);
  return performMutation(Query.getCustomerQuery, { ...payload })
    .then((response) => {
      console.log(response, "respdataaWithToken");
      // Toast({
      //   type:
      //     response?.data?.customerAccessTokenCreate?.customerAccessToken == null
      //       ? "error"
      //       : "success",
      //   message:
      //     response?.data?.customerAccessTokenCreate?.customerAccessToken == null
      //       ? response?.data?.customerAccessTokenCreate?.customerUserErrors[0]
      //           ?.message
      //       : "Logged in successfully",
      // });
      return response;
    })
    .catch((err) => {
      Toast({ type: "error", message: err?.message });
    });
};

export const Logout = (payload) => {
  // console.log("customerdddddddddddd", payload);
  return performMutation(Query.logoutCustomerQuery, { ...payload })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      Toast({ type: "error", message: err?.message });
    });
};

export const ResetPassword = (payload) => {
  return performMutation(Query.resetPasswordQuery, { ...payload })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err, "ResetPassword error")
      Toast({ type: "error", message: err?.message });
    });
};

export const CheckUserDetailToken = (payload) => {
  return performMutation(Query.checkUserDetail, { ...payload })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      Toast({ type: "error", message: err?.message });
    });
};


export const ActivateAccount = (payload) => {
  return performMutation(Query.customerActivateByUrl, { ...payload })
    .then((response) => {
      const userErrors = response?.data?.customerActivateByUrl?.customerUserErrors;

      // Check if there are any customerUserErrors
      if (!userErrors || userErrors.length === 0) {
        return response; // No errors, account activated successfully
      } else {
        const errorMessage = userErrors[0]?.message || "Activation failed";
        console.error("Error:", errorMessage);
        return Promise.reject(new Error(errorMessage));
      }
    })
    .catch((err) => {
      console.error("Error activating account:", err);
      return Promise.reject(err);
    });
};
